<div class="lazy-image-wrapper">
  <img
    [src]="src"
    [alt]="alt"
    class="lazy-image"
  />
</div> 